import "../scss/missionPage.scss";
import {Clock} from "./components/calendarCountdown";
import ReplaceContent from "./components/ReplaceContent";

new ReplaceContent();

document.addEventListener("DOMContentLoaded", function(event) {

    let countdown = document.querySelector('.countdown-timer');
    let statusWrapper = document.querySelector('.status-wrap');
    let expireDateWrapper = document.querySelector('.expiration-date-wrapper');

    if (countdown){
        let expireDate = countdown.dataset.date;
        let deadline = new Date(
            Date.parse(expireDate)// + 24 * 60 * 60 * 1000
        );
        let now = new Date();
        if(deadline > now){
            let c = new Clock(deadline, function(){
                //alert('countdown complete')
                expireDateWrapper.remove();
                statusWrapper.innerHTML = '<span class="status d-flex flex-row justify-content-center border-radius-15 font-weight-700 align-items-center mb-lg-0 mb-2 inactive">Expired</span>';
            });
            expireDateWrapper.innerHTML='';
            expireDateWrapper.appendChild(c.el);
        }else{
            expireDateWrapper.remove();
            statusWrapper.innerHTML = '<span class="status d-flex flex-row justify-content-center border-radius-15 font-weight-700 align-items-center mb-lg-0 mb-2 inactive">Expired</span>';
        }
    }

    let optInWrapper = document.querySelector('.opt-in-wrapper');

    if (optInWrapper){
        let headers = {
            "Content-Type": "text/html",
            "X-Requested-With": "XMLHttpRequest"
        };
        const token = localStorage.getItem('token') ?? '';
        if (token) {
            headers = {
                "Content-Type": "text/html",
                "X-Requested-With": "XMLHttpRequest",
                "Authorization": `Bearer ${token}`
            };
        }
        let ajaxUrl = optInWrapper.dataset.get;
        fetch(ajaxUrl, {
            method: "GET",
            headers: headers,
        })
        .then(
            response => response.json()
        )
        .then(responseText => {
            optInWrapper.innerHTML = responseText.html;
        })
        .catch(function (error) {
            console.log(error);
        });
    }

});